import LocalizedStrings from 'react-localization';
import en from './languages/english.json';

const strings = new LocalizedStrings({ en });

export default strings;
